import Points from "web/Layout/Common/Points";
import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import urls from "web/constants/urls";

import classes from "./orderSummary.scss";

type OrderSummaryProps = {
  orderNumber: string;
  totalAmount: number;
};

const OrderSummary = ({ orderNumber, totalAmount }: OrderSummaryProps) => {
  return (
    <>
      <dl className={classes.summaryList}>
        <div
          className={classes.orderNumberRow}
          data-t1="orderSummaryMain__orderNumber"
        >
          <dt>{__("Twój numer zamówienia to")}:</dt>
          <dd
            className={classes.orderNumberValue}
            data-t1="orderSummaryMain__orderNumberValue"
            data-t2={orderNumber}
          >
            {orderNumber}
          </dd>
        </div>

        <div className={classes.pointsRow}>
          <dt>{__("Zostało pobranych")}:</dt>
          <dd>
            <Points className={classes.pointsValue} points={totalAmount} />
          </dd>
        </div>
      </dl>

      <Button
        className={classes.button}
        to={urls.home}
        variant="tertiary"
        dataT1="success_page_button_continue"
      >
        {__("Kontynuuj zakupy")}
      </Button>
    </>
  );
};

export default OrderSummary;
